/** The small fixed emote set tappable during The Whisper. */
export const WHISPER_EMOTES = ['laugh', 'think', 'eyes'];
//# sourceMappingURL=protocol.js.map